import {ReactElement} from 'react'
import {BannerBodyLink, BodyContent, BodyHead, SlideContainer} from './styles'
import {Trans} from 'react-i18next'
import messages from '../../../../../../assets/messages'
import {config} from '../../../../../../config'

const websiteEducationPageHref = `${config.weblinks.websiteUrl}/education/beginner`

export function UnlockYourTradingPotentialBanner(): ReactElement {
  return (
    <SlideContainer>
      <BannerBodyLink href={websiteEducationPageHref} target="_blank">
        <BodyHead>
          <Trans
            {...messages.unlockYourTradingPotentialBannerHead}
            components={[<strong>text</strong>]}
          />
        </BodyHead>
        <BodyContent>
          <Trans {...messages.unlockYourTradingPotentialBannerBody} />
        </BodyContent>
      </BannerBodyLink>
    </SlideContainer>
  )
}
